import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DonationService } from '../../services/donation.service';
import { DonationMeterComponent } from '../donation-meter/donation-meter.component';
import { MatDialog } from '@angular/material/dialog';
import { DonationDialogComponent } from '../donation-dialog/donation-dialog.component';
import { MatRippleModule } from '@angular/material/core';

/**
 * Component providing donation information
 */
@Component({
    selector: 'app-donation',
    imports: [
        MatCardModule,
        MatButtonModule,
        MatRippleModule,
        DonationMeterComponent
    ],
    templateUrl: './donation.component.html',
    styleUrl: './donation.component.scss'
})
export class DonationComponent {
  /**
   * DI
   */
  private readonly donationService = inject(DonationService);
  private readonly dialogService = inject(MatDialog);
  donationStatus = toSignal(this.donationService.getDonationStatus(), { initialValue: {current: '0', target: '0'} });

  /**
   * Open donation dialog
   */
  openDonationDialog() {
    //console.log('DonationComponent, openDonationDialog');
    this.dialogService.open(DonationDialogComponent,{
      disableClose: true,
    });
  }

}
